import gql from 'graphql-tag';

export const PROPERTY_FRAGMENT = gql`
  fragment PropertyFragment on Property {
    id
    account_id
    client_account_id
    name
    contactName
    contactPhone
    contactEmail
    address1
    address2
    city
    state
    zip
    country
    photoUrl
    timeZone
    propertyType
    createdAt
    updatedAt
    isArchived
  }
`;
